import { ForeignParkingPanel } from './foreign-content';

interface OtherMainContentProps {
    storeCode?: string;
}

export default function OtherMainContent({ storeCode }: OtherMainContentProps) {
    return (
        <main className="widescreen:px-[calc(104*var(--vw-unit))] widescreen:pb-[calc(64*var(--vh-unit))] h-full w-full overflow-auto px-[calc(104*var(--vw-unit))] pt-[calc(72*var(--vh-unit))] pb-[calc(208*var(--vh-unit))]">
            <ForeignParkingPanel storeCode={storeCode} />
        </main>
    );
}
